import Slider from '../Slider';
import DestacatPrograma from './DestacatPrograma';
import styles from './programesDestacats.module.scss';

const ProgramesDestacatsSkeleton = (props) => {
    const { titol, skeletonItems = 4 } = props;

    return (
        <div className={styles.contDestacatPrograma}>
            <Slider format='poster-programa-destacat' titol={titol}>
                {Array.from({ length: skeletonItems }, (_, index) => (
                    <DestacatPrograma key={`poster-programa-destacat-skeleton-${index}`} isLoading={true} />
                ))}
            </Slider>
        </div>
    );
};

export default ProgramesDestacatsSkeleton;
